import apiService from "./apiService"; // Import reusable API service

const CUSTOMER_GROUPS_API_URL = "/customer-groups"; // Base endpoint for customer groups

/**
 * Fetch all customer groups
 * @returns {Promise<Object[]>} List of customer groups
 */
export const getTotalGroupCount = async () => {
  try {
    const response = await apiService.get(`${CUSTOMER_GROUPS_API_URL}/count`);
    return response.data; // Assuming API returns { data: [ { group_id, group_name } ] }
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch customer groups" };
  }
};

/**
 * Fetch all customer groups
 * @returns {Promise<Object[]>} List of customer groups
 */
export const getCustomerGroups = async () => {
  try {
    const response = await apiService.get(`${CUSTOMER_GROUPS_API_URL}/details`);
    return response.data; // Assuming API returns { data: [ { group_id, group_name } ] }
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch customer groups" };
  }
};

/**
 * Fetch all customer groups
 * @returns {Promise<Object[]>} List of customer groups
 */
export const getCustomersByGroup = async () => {
  try {
    const response = await apiService.get(`${CUSTOMER_GROUPS_API_URL}`);
    return response.data; // Assuming API returns { data: [ { group_id, group_name } ] }
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch customer groups" };
  }
};

/**
 * Fetch a customer group by ID
 * @param {number} id - ID of the customer group
 * @returns {Promise<Object>} Customer group details
 */
export const getCustomerGroupById = async (id) => {
  try {
    const response = await apiService.get(`${CUSTOMER_GROUPS_API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch customer group details" };
  }
};

/**
 * Create a new customer group
 * @param {Object} groupData - Data for the new customer group
 * @returns {Promise<Object>} Created customer group
 */
export const createCustomerGroup = async (groupData) => {
  try {
    const response = await apiService.post(CUSTOMER_GROUPS_API_URL, groupData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to create customer group" };
  }
};

/**
 * Update a customer group by ID
 * @param {number} id - ID of the customer group
 * @param {Object} groupData - Updated data for the customer group
 * @returns {Promise<Object>} Updated customer group
 */
export const updateCustomerGroup = async (id, groupData) => {
  try {
    const response = await apiService.put(`${CUSTOMER_GROUPS_API_URL}/${id}`, groupData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to update customer group" };
  }
};

/**
 * Delete a customer group by ID
 * @param {number} id - ID of the customer group
 * @returns {Promise<Object>} Response after deletion
 */
export const deleteCustomerGroup = async (id) => {
  try {
    const response = await apiService.delete(`${CUSTOMER_GROUPS_API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to delete customer group" };
  }
};
